import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.UPDATE_WEIGHT_REAL.REQUEST, saga.updateWeightReal);
    yield takeLatest(ACTION.UPDATE_WEIGHT_REAL.FAILED, saga.updateWeightRealFailed);
    yield takeLatest(ACTION.UPDATE_WEIGHT_REAL.SUCCESS, saga.updateWeightRealSuccess);
}
